import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TeslaStateReelSymbol} from "./TeslaStateReelSymbol";

export class TeslaReelPartCreator extends ReelPartCreator {

    constructor() {
        super();
    }

    // Override or create new method to create feature special symbols in subclass.
    public createNewSymbol(symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol {
        return new TeslaStateReelSymbol(symName, reelId, state);
    }

}